module.exports = __webpack_public_path__ + "img/13.3943e8c.webp";